import MusicNoteIcon from '@mui/icons-material/MusicNote';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SportsIcon from '@mui/icons-material/Sports';
import QuizIcon from '@mui/icons-material/Quiz';
import abi from './Transactions.json';
import squeezieProfile from '../assets/squeezie-profile.jpg';
import drNozmanProfile from '../assets/dr-nozman-profile.jpg';
import inoxtagProfile from '../assets/inoxtag-profile.jpg';
import notaBeneProfile from '../assets/nota-bene-profile.jpg';
import gotagaProfile from '../assets/gotaga-profile.jpg';

import entertainmentCategory from '../assets/entertainment-category-1.png';
import vulgarisationCategory from '../assets/vulgarisation.png';
import sportCategory from '../assets/sport-category.png';
import esportCategory from '../assets/esport.png';
import musicCategory from '../assets/music-category.png';
import quizCategory from '../assets/quiz-category.png';

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const recommendedChannels = [
  { channelTitle: 'SQUEEZIE', channelIcon: <img src={squeezieProfile} alt="SQUEEZIE" style={{ width: 26, height: 26, borderRadius: '50%' }} />, videoTitle: 'QUI EST L\'IMPOSTEUR ? (ft Aya Nakamura & Géraldine Nakache)', videoId: '378LFj3H_Vc' },
  { channelTitle: 'Nota Bene', channelIcon: <img src={notaBeneProfile} alt="Nota Bene" style={{ width: 26, height: 26, borderRadius: '50%' }} />, videoTitle: 'Ce qu\’on pensait sur les statues de l\’Île de Pâques était faux', videoId: '54lwdwkpAXY' },
  { channelTitle: 'Inoxtag', channelIcon: <img src={inoxtagProfile} alt="Inoxtag" style={{ width: 26, height: 26, borderRadius: '50%' }} />, videoTitle: '7 jours pour survivre en Jungle ! (avec la Légion étrangère)', videoId: 'U_nhj_Xog7c' },
  { channelTitle: 'Dr Nozman', channelIcon: <img src={drNozmanProfile} alt="Dr Nozman" style={{ width: 26, height: 26, borderRadius: '50%' }} />, videoTitle: 'Les effets terrifiants du manque de sommeil !', videoId: 'GRYoMNZDGNM' },
  { channelTitle: 'GOTAGA', channelIcon: <img src={gotagaProfile} alt="GOTAGA" style={{ width: 26, height: 26, borderRadius: '50%' }} />, videoTitle: 'Squeezie me déteste (hihihi)', videoId: 'Cf3PD37DgRY' },
];

export const visibility = [
  { value: 'PUBLIC', fr: 'Publié', translationKey: 'visibility.public' },
  { value: 'NOT_LISTED', fr: 'Non répertoriée', translationKey: 'visibility.notListed' },
  { value: 'PRIVATE', fr: 'Privé', translationKey: 'visibility.private' },
];

export const DEFAULT_VIDEO_CATEGORY = 'ENTERTAINMENT';

export const categories = [
  { name: 'Divertissement', translationKey: 'categories.entertainment', icon: <LiveTvIcon className='mui-categoriy-icons'/>, image: <img src={entertainmentCategory} alt="Divertissement" />, db: DEFAULT_VIDEO_CATEGORY},
  { name: 'Quiz & révisions', translationKey: 'categories.quiz', icon: <QuizIcon className='mui-categoriy-icons'/>, image: <img src={quizCategory} alt="Quiz" />, db: 'QUIZ'},
  { name: 'Vulgarisation scientifique', translationKey: 'categories.science', icon: <SchoolIcon className='mui-categoriy-icons'/>, image: <img src={vulgarisationCategory} alt="Vulgarisation Scientifique" />, db: 'SCIENCE'},
  { name: 'Sport', translationKey: 'categories.sport', icon: <SportsIcon className='mui-categoriy-icons'/>, image: <img src={sportCategory} alt="Sport" />, db: 'SPORT'},
  { name: 'ESport', translationKey: 'categories.esport', icon: <EmojiEventsIcon className='mui-categoriy-icons'/>, image: <img src={esportCategory} alt="Esport" />, db: 'ESPORT'},
  { name: 'Musique', translationKey: 'categories.music', icon: <MusicNoteIcon className='mui-categoriy-icons'/>, image: <img src={musicCategory} alt="Music Category" />, db: 'MUSIC'},
];

export const categDam = [
  { name: 'Damien live', icon: <DeveloperModeIcon className='mui-categoriy-icons'/>, },
];

export const demoThumbnailUrl = 'https://i.ytimg.com/an_webp/qEdoOkQOXP4/mqdefault_6s.webp?du=3000&sqp=COqNspsG&rs=AOn4CLCzB7Gc_BWbQ4uyt4wuJp2l2oW4Tg';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/EdoOkQOXP4';
export const demoChannelTitle = 'ReformistTM';
export const demoVideoTitle = 'BANNERLORD STREAM #5 - Mount & Blade 2: Bannerlord Gameplay';
export const demoProfilePicture = 'https://yt3.ggpht.com/ytc/AMLnZu_FIyVYc5Uol3T476-8JVAVbLx4wJ-qTP8MKltbNQ=s48-c-k-c0x00ffffff-no-rj';


export const contractABI = abi.abi;
export const contractAddress = '0x63E304CFBA7D300a53F3A9eFD76e7A014fFCc1f7';
export const myAddressTo = '0xCB9A9a99567808ADAdeb25D2C2570691C986DD5d'; // the tips are sent to my address for now, the time for us to register the content creators' addresses

export const getCategoryLabel = (t, categoryOrValue) => {
  if (!categoryOrValue) return '';

  const normalizedValue =
    typeof categoryOrValue === 'object'
      ? categoryOrValue.db || categoryOrValue.name || categoryOrValue.translationKey || ''
      : categoryOrValue;

  const directCategory =
    typeof categoryOrValue === 'object' &&
    (categoryOrValue.translationKey || categoryOrValue.name)
      ? categoryOrValue
      : null;

  const category =
    directCategory ||
    categories.find((item) => item.db === normalizedValue) ||
    categories.find((item) => item.name === normalizedValue) ||
    categories.find((item) => item.translationKey === normalizedValue);

  if (!category) return String(normalizedValue || categoryOrValue);
  if (!t) return category.name;

  return t(category.translationKey, { defaultValue: category.name });
};

export const getVisibilityLabel = (t, value) => {
  const normalizedValue =
    typeof value === 'object'
      ? value.value || value.translationKey || value.fr || ''
      : value;
  const item =
    (typeof value === 'object' && value.translationKey ? value : null) ||
    visibility.find((entry) => entry.value === normalizedValue);
  if (!item) return String(normalizedValue || value || '');
  if (!t) return item.fr;

  return t(item.translationKey, { defaultValue: item.fr });
};
